module.exports = __webpack_public_path__ + "img/girl.a88b122d.png";